import {FC, Ref} from "react";
import {DateInput, DateInputProps, DatePickerInput, DatePickerInputProps} from '@mantine/dates';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

/*const useStyles = createStyles((theme) => ({
    outside: {
        color: `${theme.colors.blue[1]} !important`,
    },
    weekend: {
        color: `${theme.colors.scBlue[6]} !important`,
    },
    selected: {
        color: `${theme.white} !important`,
        backgroundColor: `${theme.colors.scBlue[6]} !important`
    },
}));*/

const ScDateControl: FC<{innerRef?: Ref<HTMLInputElement>} & DateInputProps> = (inputProps: any) => {

    dayjs.extend(utc)

    const {innerRef} = inputProps;

    // const { classes, cx } = useStyles();

    return (
        <DateInput
            mt={'var(--mantine-spacing-sm)'}
            {...inputProps}
            valueFormat="D MMMM, YYYY"
            style={{'td': {borderColor: 'transparent !important'}}}
            locale="en"
            popoverProps={{withinPortal: true}}
        />
    );
};

export default ScDateControl;
